module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/Juvie-Classroom_BW-p-1600-d3ca0a859e364493bf69a330e5c340c5.jpg";